"use client";

import { Share2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface ShareButtonProps {
  onClick: () => void;
  className?: string;
  size?: "sm" | "md";
}

export function ShareButton({
  onClick,
  className,
  size = "sm",
}: ShareButtonProps) {
  const iconSize = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";

  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      className={cn(
        "inline-flex items-center justify-center rounded-md transition-[color,background-color,opacity] duration-150",
        "text-white/70 hover:text-white/80 hover:bg-white/10",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50",
        "opacity-100 sm:opacity-0 sm:group-hover:opacity-100 sm:focus-visible:opacity-100!",
        size === "sm" ? "h-11 w-11 sm:h-auto sm:w-auto sm:p-1.5" : "h-11 w-11 sm:h-auto sm:w-auto sm:p-2",
        className
      )}
      aria-label="Share this pick"
    >
      <Share2 className={iconSize} />
    </button>
  );
}
